/* this array is a series of other dictionary, each internal dictionary representing one card in the info feed. So:
so the actual format here, for a feed with one card with the title "Personal Info" would be
{
    personal_info: {
            name: "Morgan Hartley",
            email: "morganhartley@gmail.com"
        }
}

If you don't want to display the title, simply precede the key with an underscore. Such that:
     {
    _personal_info: {
            _name: "Morgan Hartley",
            _email: "morganhartley@gmail.com"
        }
}

//note that key with a null value will not display a card. so you can remove a card by setting null.

{
    personal_info: null
}

*/

let infoFeed = (state = {}, action) => {

    switch (action.type) {
        case 'CLEAR_INFO_FEED_DISPLAY':
            return {}

        case 'UPDATE_INFO_FEED_DISPLAY':
            return {
                ...state,
                ...action.data
            }

        default:
            return state
    }
}


export default infoFeed
